import {useCallback, useEffect, useRef} from 'react';
import {STATUS_POLLING_DURATION} from '../../utils/fcUploadFileUtils';

const useFCStatusPolling = (delay = STATUS_POLLING_DURATION) => {
  const timeoutRef = useRef<NodeJS.Timer>();
  const savedCallback = useRef<() => void>();
  const runningRef = useRef<boolean>(false);

  const run = useCallback(() => {
    if (!runningRef.current) return;
    savedCallback.current?.();
    timeoutRef.current = setTimeout(run, delay);
  }, [delay]);

  const setCallBack = useCallback((callback: () => void) => {
    savedCallback.current = callback;
  }, []);

  const startPolling = useCallback(() => {
    if (runningRef.current) return;
    runningRef.current = true;
    run();
  }, [run]);

  const stopPolling = useCallback(() => {
    runningRef.current = false;
    if (timeoutRef.current) {
      clearTimeout(timeoutRef.current);
      timeoutRef.current = undefined;
    }
  }, []);

  useEffect(() => {
    return () => stopPolling();
  }, [stopPolling]);

  return {startPolling, stopPolling, setCallBack};
};

export default useFCStatusPolling;
